import { IDistribution } from '../../../model/distributions/Distribution';
import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../../../model/RootStoreContext';
import { IDistributionSearchParams } from '../../../api/requests/distribution/DistributionApiGateway';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

export interface useDistributionsResult {
    isLoaded: boolean;
    distributions: IDistribution[] | null;
}

export const useDistributions = (searchParams: IDistributionSearchParams) => {
    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useDistributionsResult>({ isLoaded: false, distributions: [] });

    useEffect(() => {
        setResult({ isLoaded: false, distributions: [] });

        rootStore.distributionStore.loadDistributions(searchParams)
            .then(() => {
                setResult({ isLoaded: true, distributions: rootStore.distributionStore.distributions });
            })
            .catch(e => publishNotification({
                text: `Error loading distributions: ${e.message}`,
                canClose: true
            }));
    }, [rootStore.distributionStore, publishNotification, searchParams, rootStore.gameVersionStore.currentGameVersion, rootStore.gameEnvironmentsStore.currentGameEnvironment]);

    return result;
};
